import { h, Component } from 'preact'
import { StoreProvider } from './providers/store'
import Routing from './routing'
import './styles/global.css'
import tdlib from './utils/tdlib'

class App extends Component {
  async componentDidMount () {
    await tdlib.init()
  }

  render () {
    return (
      <StoreProvider>
        <Routing/>
      </StoreProvider>
    )
  }
}

export default App
